import { createIcon } from './createIcon'

export const GraphQLIcon = createIcon({
  displayName: 'GraphQLIcon',
  viewBox: '0 0 400 400',
  path: [
    <path
      fill="currentColor"
      d="M57.468 302.66l-14.376-8.3 160.15-277.38 14.376 8.3z"
    />,
    <path fill="currentColor" d="M39.8 272.2h320.3v16.6H39.8z" />,
    <path
      fill="currentColor"
      d="M206.348 374.026l-160.21-92.5 8.3-14.376 160.21 92.5zM345.522 132.947l-160.21-92.5 8.3-14.376 160.21 92.5z"
    />,
    <path
      fill="currentColor"
      d="M54.482 132.883l-8.3-14.375 160.21-92.5 8.3 14.376z"
    />,
    <path
      fill="currentColor"
      d="M342.568 302.663l-160.15-277.38 14.376-8.3 160.15 277.38zM52.5 107.5h16.6v185H52.5zM330.9 107.5h16.6v185h-16.6z"
    />,
    <path
      fill="currentColor"
      d="M200 330l129.641-65 8.3 14.376L200 344.376z"
    />,
    <path
      fill="currentColor"
      d="M200 394.077c-53.95 0-109.233-13.428-151.623-40.601C6.678 325.682-8.5 282.51-8.5 200s15.178-125.682 56.877-153.476C97.767 19.351 153.05 5.923 200 5.923s102.233 13.428 144.623 40.601C386.322 74.318 408.5 117.49 408.5 200s-22.178 125.682-63.877 153.476C302.233 380.649 246.95 394.077 200 394.077zM200 26.923c-49.044 0-99.817 12.178-135.608 36.77C27.234 86.69 12.5 138.132 12.5 200s14.734 113.31 51.892 136.307C100.183 360.899 150.956 373.077 200 373.077s99.817-12.178 135.608-36.77C372.766 313.31 387.5 261.868 387.5 200s-14.734-113.31-51.892-136.307C299.817 39.101 249.044 26.923 200 26.923z"
    />,
    <circle fill="currentColor" cx="200" cy="70" r="20" />,
    <circle fill="currentColor" cx="329.641" cy="135" r="20" />,
    <circle fill="currentColor" cx="329.641" cy="265" r="20" />,
    <circle fill="currentColor" cx="200" cy="330" r="20" />,
    <circle fill="currentColor" cx="70.359" cy="265" r="20" />,
    <circle fill="currentColor" cx="70.359" cy="135" r="20" />,
  ],
})
